!(function () {
  "use strict";
  var e = {
      5837: function (e, _, t) {
        t.d(_, {
          hF: function () {
            return l;
          },
        });
        var r = t(4105);
        document.getElementById("nav-wrapper");
        let c = document.querySelectorAll(".predictive-search"),
          s = document.getElementById("overlay"),
          l = () => {
            s.classList.remove("open"),
              document.body.classList.remove("active", "search"),
              c.forEach((e) => {
                e.classList.remove("open"),
                  (0, r.zx)(e.closest(".predictive-search-wrapper"));
              });
          };
      },
      4105: function (e, _, t) {
        t.d(_, {
          Ds: function () {
            return l;
          },
          St: function () {
            return a;
          },
          gp: function () {
            return s;
          },
          zx: function () {
            return i;
          },
        });
        let r = () => {},
          c = (e) => {
            "Escape" === e.key &&
              (r(), window.removeEventListener("keydown", c));
          },
          s = function () {
            let e =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              _ = arguments.length > 1 ? arguments[1] : void 0;
            _ && (r = _),
              e && window.addEventListener("keydown", c),
              e || window.removeEventListener("keydown", c);
          };
        function l(e, _) {
          let t = this,
            r;
          return function () {
            for (var c = arguments.length, s = Array(c), l = 0; l < c; l++)
              s[l] = arguments[l];
            clearTimeout(r),
              (r = setTimeout(function () {
                return e.apply(t, s);
              }, _));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            let _ = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, _, t, r) {
                return (e /= r / 2) < 1
                  ? (t / 2) * e * e + _
                  : (-t / 2) * (--e * (e - 2) - 1) + _;
              };
              let _ = document.getElementById("grid-archive-header"),
                t = document.getElementById("nav-wrapper"),
                r = 0,
                c = 0;
              _ && (r = _.offsetHeight + 50), t && (c = t.offsetHeight + 50);
              let s = e.offsetTop - r - c,
                l = window.scrollY,
                n = s - l,
                a = 0,
                i = () => {
                  a += 5;
                  let e = Math.easeInOutQuad(a, l, n, 200);
                  window.scrollTo(0, e), a < 200 && setTimeout(i, 5);
                };
              i();
            })(document.querySelector(_));
          });
        });
        let n = {};
        function a(e) {
          var _;
          let t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : e,
            r = Array.from(
              (_ = e).querySelectorAll(
                'summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
              )
            ),
            c = r[0],
            s = r[r.length - 1];
          i(),
            (n.focusin = (_) => {
              (_.target !== e && _.target !== s && _.target !== c) ||
                document.addEventListener("keydown", n.keydown);
            }),
            (n.focusout = function () {
              document.removeEventListener("keydown", n.keydown);
            }),
            (n.keydown = function (_) {
              "TAB" !== _.code.toUpperCase() ||
                (_.target !== s ||
                  _.shiftKey ||
                  (_.preventDefault(), c.focus()),
                (_.target === e || _.target === c) &&
                  _.shiftKey &&
                  (_.preventDefault(), s.focus()));
            }),
            document.addEventListener("focusout", n.focusout),
            document.addEventListener("focusin", n.focusin),
            t.focus();
        }
        function i(e) {
          document.removeEventListener("focusin", n.focusin),
            document.removeEventListener("focusout", n.focusout),
            document.removeEventListener("keydown", n.keydown),
            e && e.focus();
        }
      },
    },
    _ = {};
  function t(r) {
    var c = _[r];
    if (void 0 !== c) return c.exports;
    var s = (_[r] = { exports: {} });
    return e[r](s, s.exports, t), s.exports;
  }
  (t.d = function (e, _) {
    for (var r in _)
      t.o(_, r) &&
        !t.o(e, r) &&
        Object.defineProperty(e, r, { enumerable: !0, get: _[r] });
  }),
    (t.o = function (e, _) {
      return Object.prototype.hasOwnProperty.call(e, _);
    }),
    (function () {
      var e = t(4105),
        _ = t(5837);
      let r = document.getElementById("nav-wrapper"),
        c = document.getElementById("overlay"),
        s = () => {
          (0, _.hF)(), r.removeEventListener("click", $);
        },
        l = () => {
          let t = document.querySelectorAll(".search-input"),
            r = document.querySelectorAll(".predictive-search"),
            l = document.querySelectorAll(".predictive-search__mobile-close");
          t.forEach((_) =>
            _.addEventListener(
              "keyup",
              (0, e.Ds)(function (e) {
                if (9 != e.which) {
                  let _ = e.target.value,
                    t = e.target.getAttribute("data-predictive-search"),
                    r = document.querySelector(
                      '#predictive-search[data-predictive-search="' + t + '"]'
                    ),
                    s = r.querySelector(".search-sidebar__initial"),
                    l = r.querySelector(".search-sidebar__results");
                  r.classList.add("searching"),
                    "" !== _
                      ? fetch(
                          `/search/suggest.json?q=${_}&resources[type]=product,collection,article,page&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title`
                        )
                          .then((e) => e.json())
                          .then((e) => {
                            let t = e.resources.results.products,
                              n = e.resources.results.collections,
                              a = e.resources.results.articles,
                              p = e.resources.results.pages;
                            if (
                              (r.classList.add("open"),
                              c.classList.add("open"),
                              t.length > 0)
                            ) {
                              (r.querySelector(
                                ".no-results-notice"
                              ).style.display = "none"),
                                (r.querySelector(
                                  ".search-products__results-grid"
                                ).style.display = "grid"),
                                (r.querySelector(
                                  ".search-products"
                                ).style.display = "block"),
                                r.querySelector(".search-products__row") &&
                                  (r.querySelector(
                                    ".search-products__row"
                                  ).style.display = "none");
                              let i = document.createElement("div");
                              i.classList.add("search-products"),
                                t.forEach((e) => {
                                  var _;
                                  _ = e.featured_image.url
                                    ? `<img src="${e.featured_image.url}&width=400" alt="${e.title}" srcset="${e.featured_image.url}&width=352 352w" width="400" height="469" class="img-absolute" loading="lazy">`
                                    : '<svg class="img-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"/><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"/><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"/><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"/></svg>';
                                  let t = `<div class="card-product card"><a href="${e.url}"><figure role="none">${_}</figure><div class="card__content"><p class="card__title text-lg">${e.title}</p></div></a>`;
                                  i.innerHTML += t;
                                }),
                                (r.querySelector(
                                  ".search-products__results-grid"
                                ).innerHTML = i.innerHTML);
                            } else
                              (r.querySelector(
                                ".no-results-notice"
                              ).style.display = "flex"),
                                (r.querySelector(
                                  ".search-products"
                                ).style.display = "none");
                            let o = r.querySelector(".collection-search");
                            n.length > 0
                              ? ((r.querySelector(
                                  ".search-sidebar__collections"
                                ).innerHTML =
                                  window.searchStrings.title_results_collection),
                                (o.innerHTML = ""),
                                n.forEach((e) => {
                                  let t = document.createElement("li"),
                                    r = document.createElement("a");
                                  r.setAttribute("href", e.url);
                                  let c = e.title,
                                    s = RegExp("(" + _ + ")", "i"),
                                    l = c.replace(s, "<b>$1</b>");
                                  (r.innerHTML = l),
                                    t.appendChild(r),
                                    o.appendChild(t);
                                }))
                              : ((r.querySelector(
                                  ".search-sidebar__collections"
                                ).innerHTML =
                                  window.searchStrings.title_no_results_collection),
                                (o.innerHTML = ""));
                            let $ = r.querySelector(".article-search");
                            a.length > 0 && $
                              ? ((r.querySelector(
                                  ".search-sidebar__articles"
                                ).innerHTML =
                                  window.searchStrings.title_results_article),
                                ($.innerHTML = ""),
                                a.forEach((e) => {
                                  let t = document.createElement("li"),
                                    r = document.createElement("a");
                                  r.setAttribute("href", e.url);
                                  let c = e.title,
                                    s = RegExp("(" + _ + ")", "i"),
                                    l = c.replace(s, "<b>$1</b>");
                                  (r.innerHTML = l),
                                    t.appendChild(r),
                                    $.appendChild(t);
                                }))
                              : ((r.querySelector(
                                  ".search-sidebar__articles"
                                ).innerHTML =
                                  window.searchStrings.title_no_results_article),
                                ($.innerHTML = ""));
                            let q = r.querySelector(".page-search");
                            p.length > 0 && q
                              ? ((r.querySelector(
                                  ".search-sidebar__pages"
                                ).innerHTML = "Page results"),
                                (q.innerHTML = ""),
                                p.forEach((e) => {
                                  let t = document.createElement("li"),
                                    r = document.createElement("a");
                                  r.setAttribute("href", e.url);
                                  let c = e.title,
                                    s = RegExp("(" + _ + ")", "i"),
                                    l = c.replace(s, "<b>$1</b>");
                                  (r.innerHTML = l),
                                    t.appendChild(r),
                                    q.appendChild(t);
                                }))
                              : ((r.querySelector(
                                  ".search-sidebar__pages"
                                ).innerHTML = "No page results"),
                                (q.innerHTML = ""));
                            let h = r.querySelector(".searches-search");
                            t.length > 0 && h
                              ? ((r.querySelector(
                                  ".search-sidebar__searches"
                                ).innerHTML =
                                  window.searchStrings.title_results),
                                (h.innerHTML = ""),
                                t.forEach((e) => {
                                  let t = document.createElement("li"),
                                    r = document.createElement("a");
                                  r.setAttribute("href", e.url);
                                  let c = e.title,
                                    s = RegExp("(" + _ + ")", "i"),
                                    l = c.replace(s, "<b>$1</b>");
                                  (r.innerHTML = l),
                                    t.appendChild(r),
                                    h.appendChild(t);
                                }))
                              : ((r.querySelector(
                                  ".search-sidebar__searches"
                                ).innerHTML =
                                  window.searchStrings.title_no_results),
                                (h.innerHTML = "")),
                              (s.style.display = "none"),
                              (l.style.display = "block"),
                              r.classList.remove("searching");
                          })
                      : ((s.style.display = "block"),
                        (l.style.display = "none"),
                        (r.querySelector(".no-results-notice").style.display =
                          "none"),
                        (r.querySelector(".search-products").style.display =
                          "block"),
                        (r.querySelector(
                          ".search-products__results-grid"
                        ).style.display = "none"),
                        (r.querySelector(
                          ".search-products__row"
                        ).style.display = "block"),
                        r.classList.remove("searching"));
                }
              }, 300)
            )
          ),
            c.addEventListener("click", () => {
              (0, _.hF)(), (0, e.gp)(!1);
            }),
            l.forEach((e) => {
              e.addEventListener("click", () => {
                s();
              });
            }),
            r.forEach((e) => {
              e.addEventListener("click", (e) => {
                e.stopPropagation();
              });
            });
        };
      l();
      let n = (e) => {
          document
            .getElementById("nav-wrapper")
            .querySelectorAll("details.megamenu-open > summary")
            .forEach((e) => {
              e.classList.remove("active"),
                e.parentNode.removeAttribute("open");
            });
        },
        a = (_) => {
          let t = _.getAttribute("data-predictive-search");
          if (t) {
            let l = document.querySelector(
                '#predictive-search[data-predictive-search="' + t + '"]'
              ),
              n = document.querySelectorAll(".predictive-search");
            if (
              (n &&
                n.forEach((e) => {
                  e.classList.remove("open");
                }),
              l)
            ) {
              let a = l.closest(".predictive-search-wrapper");
              l.classList.add("open"),
                document.body.classList.add("active", "search"),
                (0, e.gp)(!0, s),
                r.addEventListener("click", $),
                c.classList.add("open"),
                setTimeout(() => {
                  l.querySelector("#SearchMobile.search-input").focus();
                }, "100"),
                (0, e.St)(a, l);
            }
          }
        },
        i = () => {
          document.querySelectorAll(".search-trigger").forEach((e) => {
            e.addEventListener("click", () => {
              a(e), n();
            }),
              e.addEventListener("focus", () => {
                a(e), n();
              });
          });
        };
      i();
      let o = () => {
        document.querySelectorAll(".button.search-input").forEach((e) => {
          e.addEventListener("click", (e) => {
            "" ===
              e.target.parentNode.querySelector('input[type="search"]').value &&
              (e.preventDefault(), e.stopPropagation());
          });
        });
      };
      o();
      let $ = (e) => {
        window.matchMedia("(min-width: 1024px)").matches &&
          (e.target.classList.contains("search-trigger") ||
            e.target.classList.contains("search-icon") ||
            s());
      };
      Shopify.designMode &&
        document.addEventListener("shopify:section:load", () => {
          o(), i(), l();
        });
    })();
})();
